import { Component, AfterContentInit, Injectable, ViewChild, ViewContainerRef, HostListener, Input, ElementRef, OnDestroy } from '@angular/core';
import { ServiceLocator } from '../../../ServiceLocator';
import { HttpClient } from '@angular/common/http';
import { UserPrefs, MainViewPrefs } from '../../../api/UserPrefs-dto';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store/AppState';
import {
  BehaviorSubject,
  Observable,

} from '../../../../../node_modules/rxjs';
import { PDFDocumentProxy } from 'ng2-pdf-viewer';
import { generateRandomIdentifier } from '../../../ui.service';
import { HeaderActionsService } from '../sub-header/header-actions.service';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng-lts/dynamicdialog';
import { BaseDirectiveObject } from '../base-directive-object';
import { BaseComponent } from '../baseComponent/base.component';
import { UserPrefsService } from '../../../store/user-prefs.service';

declare var jQuery: any;

@Injectable()
export class WelcomeNotesService extends BaseDirectiveObject {
  private notes: BehaviorSubject<Array<WelcomeNotesDTO>> = new BehaviorSubject<
    Array<WelcomeNotesDTO>
  >([]);
  public welcomeNotes: Observable<
    Array<WelcomeNotesDTO>
  > = this.notes.asObservable();

  // INFORMACION DE LA PANTALLA ALMACENADA EN SESION
  private userPrefs: UserPrefs;
  private dialogService;


  constructor(
    private http: HttpClient,
    private store: Store<AppState>,
    private userPrefsService: UserPrefsService
  ) {
    super();
    this.dialogService = ServiceLocator.injector.get(DialogService);
    this.subscribe(this.userPrefsService.getUserPrefs(),
      (prefs: UserPrefs) => {
        this.userPrefs = prefs;

        if (!this.userPrefs.mainViewPrefs) {
          this.userPrefs.mainViewPrefs = new MainViewPrefs();
        }
        if (!this.userPrefs.mainViewPrefs.welcomeNotesViewed) {
          this.userPrefs.mainViewPrefs.welcomeNotesViewed = [];
        }
      });
    this.subscribe(this.http
      .get<WelcomeNotesDTO[]>('assets/docs/welcome-notes.json'),
      data => this.notes.next(data),
      err => console.log(err),
      () => console.log('Completed')
    );
  }

  viewNote(id: string) {
    if (this.notes) {
      // Solo mostramos el primero de los no visualizados
      this.notes.value.some(x => {
        if (id === x.id) {
          this.viewFile('assets/docs/' + x.id + '.pdf');
          this.userPrefs.mainViewPrefs.welcomeNotesViewed.push(x.id);
          return true;
        }
      });
    }
  }

  viewNotes() {
    if (this.notes) {
      // Solo mostramos el primero de los no visualizados
      this.notes.value.some(x => {
        if (
          this.userPrefs.mainViewPrefs.welcomeNotesViewed.indexOf(x.id) === -1
        ) {
          this.viewFile('assets/docs/' + x.id + '.pdf');
          this.userPrefs.mainViewPrefs.welcomeNotesViewed.push(x.id);
          return true;
        }
      });
    }
  }

  private viewFile(fileSrc: string) {
    let context = new WelcomeNotesModal(fileSrc);

    let config: DynamicDialogConfig = {
      /// header: ,
      width: '70%',
      style: { overflow: 'scroll', 'max-height': '80%' }
    };
    config['context'] = context;
    return this.dialogService.open(welcomeNotesComponent, config);
  }
}

export class WelcomeNotesDTO {
  id: string;
  description: string;
}

export class WelcomeNotesModal {
  public fileSrc: string;
  constructor(public fileSrcParameter: string) {
    this.fileSrc = fileSrcParameter;
  }
}

@Component({
  selector: 'welcome-notes-viewer',
  templateUrl: 'welcomeNotes.template.html'
})
export class welcomeNotesComponent extends BaseComponent implements AfterContentInit, OnDestroy {



  numberPages = 0;
  pdfSrc: any;
  page = 1;
  rotation = 0;
  zoom = 1;
  originalSize = false;
  showAll = true;

  pdf: any;
  zoomFactor = 1;
  @ViewChild('viewer')
  pdfViewer: ViewContainerRef;

  @Input()
  showZoom: boolean;
  @Input()
  showPages: boolean;
  @Input()
  showToolbar: boolean;
  @Input()
  showRotation: boolean;
  @Input()
  showExpandButton = true;
  @Input()
  showAllPagesDocument: boolean;

  windowHash: string;

  constructor(
    public ref: DynamicDialogRef,
    public dialogConfig: DynamicDialogConfig,
    private elem: ElementRef,
    private headerActionsService: HeaderActionsService,
  ) {
    super();
    this.pdfSrc = dialogConfig['context'].fileSrc;
  }

  ngOnDestroy() {
    this.headerActionsService.clearWindowActions(this.windowHash);
    this.dialogConfig = null;
    this.pdfViewer = null;
    this.pdfSrc = null;
    super.ngOnDestroy();
  }


  ngAfterContentInit(): void {
    this.zoom = this.pdfViewer.element.nativeElement.offsetParent.clientWidth / 1200;

    this.windowHash = generateRandomIdentifier();

    //this.headerActionsService.setTaskDescription(this.elem, 'Actions.execute', 'fas fa-share', true);


    this.headerActionsService.clearWindowActions(this.windowHash);





    this.subscribe(this.headerActionsService.addWindowAction(
      'General.close',
      'fas fa-times',
      'btn-outline-secondary',
      true, this.windowHash
    ),
      success => {
        this.ref.close();
      });

  }
  @HostListener('window:resize', ['$event'])
  onPageResize() {
    this.zoom = this.pdfViewer.element.nativeElement.offsetParent.clientWidth / 1200;
  }
  afterLoadComplete(pdf: PDFDocumentProxy) {
    console.log('afterLoadComplete');
    this.pdf = pdf;

  }




  public initPage(): boolean {
    if (this.page == 1) {
      return true;
    }
    return false;
  }

  public lastPage(): boolean {
    if (this.page == this.pdf.numPages) {
      return true;
    }
    return false;
  }


  incrementZoom(amount: number) {
    this.zoom += amount;


  }

  rotate(angle: number) {
    this.rotation += angle;
  }

  incrementPage(amount: number) {
    this.page += amount;

  }


  public isShowToolbar(): boolean {
    return this.showToolbar;
  }

  public isShowPages(): boolean {
    return this.showPages;
  }

  public isShowZoom(): boolean {
    return this.showZoom;
  }

  public isShowRotation(): boolean {
    return this.showRotation;
  }

  public isShowAllPagesDocument(): boolean {
    return this.showAllPagesDocument;
  }


  close(): void {
    this.ref.close();
  }

}
